import { isFeatureEnabled } from 'owa-feature-flags';
import CalendarEntry from 'owa-service/lib/contract/CalendarEntry';
import CalendarFolderTypeEnum from 'owa-service/lib/contract/CalendarFolderTypeEnum';
import LinkedCalendarEntry from 'owa-service/lib/contract/LinkedCalendarEntry';
import { trace } from 'owa-trace';

const LINKEDCALENDAR_ENTRY_TYPE = 'LinkedCalendarEntry:#Exchange';

export function shouldAddCalendarToCache(
    calendarEntry: CalendarEntry,
    calendarKeys: string[]
): boolean {
    if (calendarEntry.CalendarFolderType == CalendarFolderTypeEnum.SchedulesCalendar) {
        return false;
    } else if (isLinkedCalendar(calendarEntry)) {
        // linked calendar entry
        let linkedCalendarEntry: LinkedCalendarEntry = calendarEntry;

        if (linkedCalendarEntry.IsOwnerEmailAddressInvalid) {
            // If the calendar points to a user that is not valid (i.e. AD lookup failed)
            // We do not create a corresponding folder model.
            trace.info(
                `[getCalendarsService] Ommitting shared calendar with IsOwnerEmailAddressInvalid flag on, OwnerEmailAddress: {1}: ${
                    linkedCalendarEntry.OwnerEmailAddress
                }`
            );
            return false;
        }

        let calendarKey = linkedCalendarEntry.IsGeneralScheduleCalendar
            ? linkedCalendarEntry.OwnerEmailAddress
            : linkedCalendarEntry.SharedFolderId
            ? linkedCalendarEntry.SharedFolderId.Id
            : null;

        if (!calendarKey) {
            trace.info(
                `[getCalendarsService] Ommitting linked calendar with null SharedFolderId, Id: {1}: ${
                    calendarEntry.ItemId.Id
                }`
            );
            return false;
        }

        if (calendarKeys.includes(calendarKey)) {
            trace.info(
                `[getCalendarsService] Ommitting duplicate shared calendar from Calendar folder list. DuplicateKey: {1}: ${calendarKey}`
            );
            return false;
        } else {
            calendarKeys.push(calendarKey);
        }

        linkedCalendarEntry.OwnerEmailAddress = linkedCalendarEntry.OwnerEmailAddress.toLowerCase();

        if (linkedCalendarEntry.IsGroupMailboxCalendar) {
            return false;
        }
    }

    return true;
}

function isLinkedCalendar(calendarEntry: CalendarEntry): boolean {
    return isFeatureEnabled('cal-linkedCalendarEntry')
        ? calendarEntry.__type == LINKEDCALENDAR_ENTRY_TYPE
        : calendarEntry.hasOwnProperty('OwnerEmailAddress');
}
